import React from 'react';
import { Link } from 'react-router-dom';
import { AwardIcon, CheckCircleIcon, GraduationCapIcon, ArrowRightIcon } from 'lucide-react';
export function LeadershipPage() {
  return <div className="pt-20" data-id="element-323">
      <section className="bg-brand-navy py-24 text-white" data-id="element-324">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-325">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-326">
            Our Leadership
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-327">
            Over 20 years of combined clinical medical experience and advanced
            mental health expertise.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-328">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-329">
          <div className="space-y-24" data-id="element-330">
            {/* Founder */}
            <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-331">
              <div className="order-2 lg:order-1" data-id="element-332">
                <div className="inline-block bg-brand-red/10 text-brand-red px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-333">
                  Founder & Clinical Director
                </div>
                <h2 className="text-3xl font-bold text-brand-navy mb-6" data-id="element-334">
                  Experienced Nurse Practitioner
                </h2>
                <p className="text-lg text-gray-600 mb-8" data-id="element-335">
                  Highly experienced Nurse Practitioner with over 15 years of
                  clinical experience in both private and government hospital
                  systems.
                </p>
                <div className="grid sm:grid-cols-2 gap-4" data-id="element-336">
                  {['Family practice and primary care', 'Critical care support', 'Chronic disease management', 'Preventive health and wellness', 'Health risk assessments', 'Patient-centered care coordination'].map(item => <div key={item} className="flex items-start" data-id="element-337">
                      <CheckCircleIcon className="h-5 w-5 text-brand-red mr-2 mt-1 flex-shrink-0" data-id="element-338" />
                      <span className="text-gray-700 font-medium" data-id="element-339">{item}</span>
                    </div>)}
                </div>
              </div>
              <div className="order-1 lg:order-2" data-id="element-340">
                <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&q=80&w=1000" alt="Clinical Director" className="rounded-3xl shadow-2xl" data-id="element-341" />
              </div>
            </div>

            {/* Co-Founder */}
            <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-342">
              <div data-id="element-343">
                <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=1000" alt="Mental Wellness Director" className="rounded-3xl shadow-2xl" data-id="element-344" />
              </div>
              <div data-id="element-345">
                <div className="inline-block bg-brand-navy/10 text-brand-navy px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-346">
                  Co-Founder & Mental Wellness Director
                </div>
                <h2 className="text-3xl font-bold text-brand-navy mb-6" data-id="element-347">
                  Board-Certified Master Mental Health Coach
                </h2>
                <p className="text-lg text-gray-600 mb-8" data-id="element-348">
                  Over 13 years of leadership and strategic development
                  expertise. SYMBIS Marriage Facilitator and Couples Repair
                  Specialist.
                </p>
                <div className="grid sm:grid-cols-2 gap-4" data-id="element-349">
                  {['Marriage restoration', 'Grief & Loss specialist', 'Trauma recovery', 'Mood Disorders support', 'Life recovery coaching', 'Geriatric mental wellness'].map(item => <div key={item} className="flex items-start" data-id="element-350">
                      <AwardIcon className="h-5 w-5 text-brand-red mr-2 mt-1 flex-shrink-0" data-id="element-351" />
                      <span className="text-gray-700 font-medium" data-id="element-352">{item}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-brand-light" data-id="element-353">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-354">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6" data-id="element-355">
            Work with Our Expert Team
          </h2>
          <p className="text-lg text-gray-600 mb-10" data-id="element-356">
            Benefit from over 20 years of combined clinical and mental health
            expertise.
          </p>
          <Link to="/contact" className="inline-flex items-center bg-brand-navy text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-brand-red transition-all shadow-xl group" data-id="element-357">
            Connect with Us
            <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-358" />
          </Link>
        </div>
      </section>
    </div>;
}